import { z } from 'zod'
import { ReactNode } from 'react'
import { UseQueryOptions } from '@tanstack/react-query'


export const MultipleErrorsSchema = z.array(z.string())


const ApiErrorBodySchema = z.object({
  code: z.number(),
  message: z.string(),
  details: z.record(z.unknown()).nullable(),
})
export type RequestError = z.infer<typeof ApiErrorBodySchema>

const ApiErrorSchema = z.object({
  error: ApiErrorBodySchema,
})

export type APIError = z.infer<typeof ApiErrorSchema>

export const instanceOfError = (object: any): object is APIError => {
  const result = ApiErrorSchema.safeParse(object)
  return result.success
}

export const REQUEST_STATUS = {
  IDLE: 'idle',
  IN_FLIGHT: 'in_flight',
  SUCCESS: 'success',
  FAILED: 'failed',
} as const

export type RequestStatus = (typeof REQUEST_STATUS)[keyof typeof REQUEST_STATUS]

export type PageDetailsType = {
  path: string
  title: string
  description: string
}

export type ChildrenProp = { children: ReactNode }

export type ThunkRequestState = {
  status: RequestStatus
  error: RequestError
  isFirstFetch?: boolean
}
export type NoContent = ''
export type RequestResponse<T> =
  | {
      error: null
      data: T
    }
  | {
      error: RequestError
      data: null
    }

//https://tkdodo.eu/blog/react-query-and-type-script#the-four-generics
export type CustomQueryOptions<
  QueryFuncReturnData,
  SelectData = QueryFuncReturnData,
  QueryFuncError = Error,
> = Omit<
  UseQueryOptions<QueryFuncReturnData, QueryFuncError, SelectData>,
  'queryKey' | 'queryFn' | 'initialData'
>
